// extracted by mini-css-extract-plugin
export default {"root":"_2da1m","heading-and-subheading-block":"_3Wk9U","headingAndSubheadingBlock":"_3Wk9U","subheading":"_15KOs"};